import { Col, Result, Row, Space, Spin, Typography } from 'antd';
import { useLoader } from '../../context/loaderContext';
import "./commonStyles.scss";
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

const Loader = () => {
    const { loading, loadingText, hasError } = useLoader();

    if (!loading) return null;

    if (hasError) {
        return (
            <Result
                className='loaderResult'
                status="warning"
                title="There is a problem loading this page. Please Try again"
            />
        )
    }

    return (
        <Row gutter={16}>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} style={{ display: "flex", justifyContent: "center" }}>
                <Space direction='vertical' align='center'>
                    <Spin indicator={<LoadingOutlined spin />} size="large" />
                    <Text style={{ marginTop: 20 }}>{loadingText ? loadingText : "Loading..."}</Text>
                </Space>
            </Col>
        </Row>
    );
}
export default Loader;